// ステータス
export class Status {
    timerholder;
    digit;
    poseholder;

    constructor(){
        this.timerholder = document.getElementById('timer');
        this.digit = document.getElementById('digit');
        this.poseholder = document.getElementById('pose');
    }

    AddClass(classname = 'none'){
        if(classname != 'none'){
            this.digit.classList.add(classname);
        }
    }
    RemoveClass(classname = 'none'){
        if(classname != 'none'){
            this.digit.classList.remove(classname);
        }
    }
    RemoveAndAddClass(classname = 'none'){
        if(classname != 'none'){
            this.digit.classList.remove(classname);
            this.digit.offsetWidth; //魔法のおまじない！ https://qiita.com/ikuo00uk/items/1f9e172c2a7186c6777d
            this.digit.classList.add(classname);
        }
    }

    TimerOut(str) {
        // 時間出力
        if (this.digit != null) {
            this.digit.innerText = str;
        }
    }

    Show() {
        if (this.timerholder != null) {
            this.timerholder.style.display = 'block';
        }
    }
    Hide() {
        if (this.timerholder != null) {
            this.timerholder.style.display = 'none';
        }
    }

    //Poseデータの出力
    PoseOut(str) {
        if (this.poseholder != null) {
            this.poseholder.innerText = str;
        }
    }
}